module.exports = __webpack_public_path__ + "assets/img/ningbo.bf07653f.png";